import { render, staticRenderFns } from "./OrderListCanceledPage.vue?vue&type=template&id=04064f21&scoped=true&"
import script from "./OrderListCanceledPage.vue?vue&type=script&lang=js&"
export * from "./OrderListCanceledPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04064f21",
  null
  
)

export default component.exports